module["exports"] = [
  "#{first_name}#{last_name}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_CN/name/name.js
// module id = 1391
// module chunks = 0